import React from "react";
import { Container } from "./DetailContent.styled";

export interface DetailContentProps {
  children: React.ReactNode;
}

const DetailContent = ({ children }: DetailContentProps) => {
  return (
    <Container>
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell small-12 large-8 large-offset-2">{children}</div>
        </div>
      </div>
    </Container>
  );
};

export default DetailContent;
